// POUR LA BARRE POLITIQUE DE CONFIDENTIALITE

// try {
// 	var myDocument = document.getElementById("iframeStorage"); // on récupere l'iframe du storage.timothee.fr
// 	if (myDocument) {
// 		var iframeStorage = myDocument.contentWindow;
// 	}
// } catch (error) {}

export const isAcceptCookies = () => {
	if (localStorage.getItem("cookies") === "true") {
		return true;
	} else {
		return false;
	}
};

export const acceptCookiesTrue = () => {
	localStorage.setItem("cookies", "true");
	// let packet = {
	// 	methode: "postCookies",
	// 	cookies: "true"
	// };
	// if (iframeStorage) {
	// 	iframeStorage.postMessage(packet, "https://storage.timothee.fr");
	// }
};

export const getUserParsed = () => {
	return JSON.parse(localStorage.getItem("tmpUser") || "{}");
};

export const setUserJson = userJson => {
	localStorage.setItem("tmpUser", userJson);
	// let packet = {
	// 	methode: "postUser",
	// 	user: JSON.parse(userJson)
	// };
	// if (iframeStorage) {
	// 	iframeStorage.postMessage(packet, "https://storage.timothee.fr");
	// }
};

export const setAuthoritiesJson = authoritiesJson => {
	console.log("On injecte les authorities : " + authoritiesJson);
	localStorage.setItem("authorities", authoritiesJson);
	const data = localStorage.getItem("authorities");
	console.log("Données lues:", data);
};

export const getAuthoritiesJson = () => {
	return JSON.parse(localStorage.getItem("authorities") || "[]");
};

export const removeAuthorities = () => {
	localStorage.removeItem("authorities");
};

export const initUser = () => {
	if (JSON.parse(localStorage.getItem("authorities")) === null) {
		console.log("on est dedans");
		localStorage.setItem("authorities", JSON.stringify(["ROLE_PUBLIC"]));
		window.location.reload();
	}
};

export const removeUser = () => {
	localStorage.removeItem("tmpUser");
	// let packet = {
	// 	methode: "removeUser"
	// };
	// if (iframeStorage) {
	// 	iframeStorage.postMessage(packet, "https://storage.timothee.fr");
	// }
};
